import Maps from "../components/maps";

const MapsPage = () => {
  return <Maps />;
};

export default MapsPage;
